/* naawm / Nox — révélation au scroll (progressive enhancement, ~0.4 Ko) */
(function () {
  if (window.__noxReveal) return;
  window.__noxReveal = true;
  document.documentElement.classList.add('nox-js');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nox-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  function scan() {
    document.querySelectorAll('[data-nox-reveal]:not(.nox-obs)').forEach(function (el) {
      el.classList.add('nox-obs');
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
